// extracted by mini-css-extract-plugin
module.exports = {"not_found":"NotFound_not_found__AxFLK","link":"NotFound_link__SPICF"};